import { handleActions } from 'redux-actions';

const INITIAL_STATE = {
  issuePanelData: [],
  paginationData: {},
};

const IssuePanelReducer = handleActions(
  {
    GET_ISSUE_PANEL_DATA: (state, action) => {
      return {
        ...state,
        issuePanelData: action.payload,
      };
    },
    GET_PAGINATION_DATA: (state, action) => {
      return {
        ...state,
        paginationData: action.payload,
      };
    },
    GET_HISTORY_ISSUE_DATA: (state, action) => {
      return {
        ...state,
        historyIssueData: action.payload,
      };
    },
  },
  INITIAL_STATE,
);

export default IssuePanelReducer;
